import { useFindById, useFindByName } from '@/context/SelectComponent/Base';
import { useGetExcisesAllSuspense } from '@/context/services/excise/Excise.service';
import { Excises } from 'ap-openapi';

export const useFindExcise = () => {
  const items = useGetExcisesAllSuspense();
  const findById = useFindById<Excises, 'id', 'long_name'>(items, {
    key: 'id',
    return: 'long_name',
    defaultVal: '',
  });
  const findByName = useFindByName<Excises, 'long_name', 'id'>(items, {
    key: 'long_name',
    return: 'id',
    defaultVal: '',
  });
  return {
    findExciseById: findById,
    findExciseByName: findByName,
  };
};
